import React from 'react';

import { useSelector } from 'react-redux';
import { useIntl } from 'react-intl';

import { selectKycDocumentSOWQ } from '@/store/selectors/kycSelectors';
import { KycSection } from '@/pages/settings/verify/kyc-sections/KycSection';
import { GTagEvents, triggerGTag } from '@/lib/gTagManager';
import { VerificationStatus } from '@lucky7ventures/bff-types';
import { useModal } from '@/features/modal/useModal';
import { MODALS } from '@/features/modal/types';

export function KycSowq(): JSX.Element | null {
  const sowqKyc = useSelector(selectKycDocumentSOWQ);
  const intl = useIntl();
  const { openModal } = useModal();

  if (!sowqKyc) {
    return null;
  }

  return (
    <KycSection status={sowqKyc.status} title={intl.formatMessage({ id: 'verify.sow.header' })}>
      <p>{intl.formatMessage({ id: 'verify.sow.text' })}</p>
      {[
        VerificationStatus.Requested,
        VerificationStatus.UserRequested,
        VerificationStatus.Rejected,
      ].indexOf(sowqKyc.status) > -1 && (
        <button
          type="button"
          className="mt-8 flex items-center justify-center rounded-full bg-blue-light px-6 py-4 font-bold text-white shadow-md transition hover:bg-cyan-600 hover:shadow-lg md:w-auto"
          onClick={() => {
            triggerGTag(GTagEvents.sowq_modal_open);
            openModal(MODALS.SOURCE_OF_WEALTH_QUESTIONNAIRE);
          }}
        >
          {intl.formatMessage({ id: 'verify.sow.button' })}
        </button>
      )}
    </KycSection>
  );
}
